import React, { useEffect } from 'react';

// assets

// services

// props

// components
import { ActionButton, Link, Stack, TagPicker } from '@fluentui/react';
import Label from '../../../typography/label';
import Text from '../../../typography/text';
import PermissionsService from '../../../../services/permissions';
import { useStore } from '../../../../stores/root';
import ISubsidiariesResourceShort from '../../../../props/data/subsidiaries';
import { IVesselResourceShortProps } from '../../../../props/vessels/vessel';
import VesselService from '../../../../services/vessels/vessel';
import VesselForm from '../../../vessels/general/form';

type SelectVesselProps = {
    subsidiary?: ISubsidiariesResourceShort;
    selected?: IVesselResourceShortProps;
    options?: IVesselResourceShortProps[];
    qs?: string[];
    label?: string;
    hideLabel?: boolean;
    required?: boolean;
    disabled?: boolean;
    allowCreate?: boolean;
    onChange(selected?: IVesselResourceShortProps): void;
}

const SelectVessel: React.FC<SelectVesselProps> = (props: SelectVesselProps) => {
    const { user } = useStore();
    const [activeSurface, setActiveSurface] = React.useState<string | undefined>();
    const [selected, setSelected] = React.useState<IVesselResourceShortProps | undefined>();

    useEffect(() => {
        setSelected(props.selected);
    }, [props.selected]);

    useEffect(() => {
    }, [props]);

    const _onSearchVessel = async (keyword: string) => {
        try {
            if (props.options) {
                return props.options.map((item) => ({
                    key: item.id,
                    name: item.name,
                    metadata: item
                }));
            } else {
                const qs: string[] = props.qs || [];
                if (props.subsidiary) { qs.push(`subsidiary_id=${props.subsidiary.id}`) }
                if (keyword && keyword.trim() !== '') { qs.push(`search=${keyword}`) }

                const options = (await VesselService.retrieve(qs.join("&"))).data.map((item) => ({
                    key: item.id,
                    name: item.name,
                    metadata: item
                }));

                return options;
            }
        } catch (error) {
            return [];
        }
    }

    return <Stack>
        {props.hideLabel ? null : <Label style={{padding: '2px 0px 1px'}} size={'xsmall'} required={props.required}>{props.label || "Vessel"}</Label>}
        {!selected ? <>
            <TagPicker
                disabled={props.disabled}
                selectedItems={[]}
                removeButtonAriaLabel='Remove'
                itemLimit={1}
                onItemSelected={(item: any) => {
                    const selected = item ? item.metadata : undefined;
                    props.onChange(selected);

                    return null;
                }}
                onRenderSuggestionsItem={(props: any) => {
                    const md = props.metadata as IVesselResourceShortProps;

                    return <Stack styles={{ root: { padding: 5 }}} horizontalAlign='baseline'>
                        <Label size={'small'}>{md.name}</Label>
                        <Text size={'small'}>{md.subsidiary.name}</Text>
                    </Stack>;
                }}
                onResolveSuggestions={_onSearchVessel}
                onEmptyResolveSuggestions={() => _onSearchVessel('')}
            />
            {props.allowCreate && PermissionsService.hasPermission(['vessels.create'], user.permissions) ? <Text size={'small'}>Cannot find vessel? <Link onClick={() => {setActiveSurface('create')}}>Click here</Link> to create vesel</Text> : null}
        </> : null}
        {selected ? <Stack styles={{ root: { padding: 8 } }} className={'card'} horizontal tokens={{ childrenGap: 20 }} horizontalAlign={'space-between'} verticalAlign='center'>
            <Stack>
                <Label size={'small'}>{selected.name}</Label>
                {selected.subsidiary ? <Text size={'small'}>{selected.subsidiary.name}</Text> : null}
            </Stack>
            {!props.disabled ? <ActionButton iconProps={{ iconName: "Delete" }} onClick={() => { props.onChange(); }} /> : null}
        </Stack> : null}
        {activeSurface === 'create' ? <VesselForm onDismissed={(refresh, status, vessel) => {
            setActiveSurface(undefined);
            props.onChange(vessel);
        }} /> : null}
    </Stack>;
};

export default SelectVessel;
